<template>
  <div v-if="!isBlank && !isRowLoading"
       class="main-container">
    <div :id="elementID"
         ref="storyTitle"
         v-bind:class="{
          'story-title': true && !$isIsef,
          'hasNoBottomMargin':hasNoBottomMargin,
          'story-title-isef': $isIsef ,
          'story-title-isef-search': $isIsef && isSearch,
         }"
         v-line-clamp="titleLines">
      {{ title }}
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import breakpoints from '@/libs/breakpoints'
import lineClamp from 'vue-line-clamp'
Vue.use(lineClamp, {
  textOverflow: 'ellipsis'
})
export default {
  props: ['isRowLoading', 'isBlank', 'title', 'elementID', 'customLineClamp', 'hasNoBottomMargin'],
  computed: {
    isEngCom: function () {
      return this.$isEngCom
    },
    isIsef: function () {
      return this.$isIsef
    },
    isMobile: function () {
      return breakpoints.isMobile()
    },
    titleLines: function () {
      return this.customLineClamp ? this.customLineClamp : 2
    },
    isSearch: function () {
      return this.$route.name === 'search'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .story-title {
    overflow: visible;
    word-break: break-word !important;
    font-family: $primary-font;
    color: $black;
    font-weight: 600;
    font-size: 1rem;
    line-height: 1.45;
    margin: 0.5rem 0.75rem;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    color: var(--background-third);
    @include mobile {
      font-size: 0.9rem;
      font-weight: 500;
      line-height: 1.45;
      margin: 0.5rem;
    }
    &-isef {
      overflow: visible;
      word-break: break-word !important;
      font-family: 'Helvetica Neue' !important;
      font-style: normal;
      font-weight: 500;
      font-size: 1em !important;;
      line-height: 20px;
      color: #FFFFFF !important;
      margin: 1rem 1rem 0 1rem !important;
      &-search {
        margin: 0 1rem 0 1rem !important;
      }
    }
  }
  .story-title-projectboard {
    font-family: 'Helvetica Neue';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    overflow: visible;
    word-break: break-word !important;
    color: white;
    margin: 0.5rem 0.75rem;
    display: flex;
    justify-content: center;
    align-items: left;
  @include mobile {
    font-size: 0.9rem;
    font-weight: 500;
    line-height: 1.45;
    margin: 0.5rem;
  }
  }
  .hasNoBottomMargin {
    margin-bottom: 0;
    min-height: 20px !important;
  }
  .main-container {
    height: auto;
  }
</style>
